Vendd.Scripts.load(function () {

    initSocialShare = function () {

        var $wrappers = $('.js-share-buttons-three');

        $wrappers.each(function () {
            var $wrapper = $(this);
            $wrapper.attr("social-setup", true);

            if ($wrapper.hasClass('initialized')) {
                return;
            } else {
                $wrapper.addClass('initialized');
            }

            var linkUrl = window.location.origin + $wrapper.data("url");

            if (typeof $wrapper.data('facebook') !== 'undefined') {
                var facebookUrl = "http://api.addthis.com/oexchange/0.8/forward/facebook/offer?pco=tbx32nj-1.0&url={{Url}}";
                facebookUrl = facebookUrl.replace("{{Url}}", linkUrl);
                $wrapper.append($("<a>").addClass("social-link addthis_button_facebook facebook icon-facebook").attr("href", facebookUrl).attr("target", "_blank").append($("<span>").addClass("text").text('facebook')));
            }

            if (typeof $wrapper.data('twitter') !== 'undefined') {
                var twitterUrl = "http://api.addthis.com/oexchange/0.8/forward/twitter/offer?pco=tbx32nj-1.0&url={{Url}}";
                twitterUrl = twitterUrl.replace("{{Url}}", linkUrl);
                $wrapper.append($("<a>").addClass("social-link addthis_button_twitter twitter icon-twitter").attr("href", twitterUrl).attr("target", "_blank").append($("<span>").addClass("text").text('twitter')));
            }

            if (typeof $wrapper.data('pinterest') !== 'undefined') {
                var pinterestUrl = "http://api.addthis.com/oexchange/0.8/forward/pinterest_share/offer?pco=tbx32nj-1.0&url={{Url}}";
                pinterestUrl = pinterestUrl.replace("{{Url}}", linkUrl);
                $wrapper.append($("<a>").addClass("social-link addthis_button_pinterest printerest icon-pinterest").attr("href", pinterestUrl).attr("target", "_blank").append($("<span>").addClass("text").text('pinterest')));
            }

            if (typeof $wrapper.data('email') !== 'undefined') {
                var forwardEmail = "http://api.addthis.com/oexchange/0.8/forward/email/offer?pco=tbx32nj-1.0&url={{Url}}";
                forwardEmail = forwardEmail.replace("{{Url}}", linkUrl);
                $wrapper.append($("<a>").addClass("social-link addthis_button_email mail icon-mail").attr("href", forwardEmail).attr("target", "_blank").append($("<span>").addClass("text").text('mail')));
            }

        });

    }
    initSocialShare();

});
